import React from 'react'
import { withIcon } from '../../withIcon'

function XIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.18306 5.55806C5.42714 5.31398 5.82286 5.31398 6.06694 5.55806L11.625 11.1161L17.1831 5.55806C17.4271 5.31398 17.8229 5.31398 18.0669 5.55806C18.311 5.80214 18.311 6.19786 18.0669 6.44194L12.5089 12L18.0669 17.5581C18.311 17.8021 18.311 18.1979 18.0669 18.4419C17.8229 18.686 17.4271 18.686 17.1831 18.4419L11.625 12.8839L6.06694 18.4419C5.82286 18.686 5.42714 18.686 5.18306 18.4419C4.93898 18.1979 4.93898 17.8021 5.18306 17.5581L10.7411 12L5.18306 6.44194C4.93898 6.19786 4.93898 5.80214 5.18306 5.55806Z" fill={color}/>
    </svg>
  )
}

export default withIcon(XIcon)
